import { useEffect } from 'react';
import { normalizeSchemaUrls } from '../lib/publicUrls';

const SEO = ({ title = '', description = '', keywords = '', schema = null }) => {
  useEffect(() => {
    const siteTitle = 'Delta Valley Health Club';
    const pageTitle = title ? `${title} | ${siteTitle}` : siteTitle;
    const defaultDescription = 'Your Premier Hometown Health Club in Brentwood, CA. Personal training, reformer Pilates, swimming, childcare, and more since 2002.';
    const pageDescription = description || defaultDescription;
    
    // Update document title
    document.title = pageTitle;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.name = 'description';
      document.head.appendChild(metaDescription);
    }
    metaDescription.content = pageDescription;
    
    // Update keywords if provided
    if (keywords) {
      let metaKeywords = document.querySelector('meta[name="keywords"]');
      if (!metaKeywords) {
        metaKeywords = document.createElement('meta');
        metaKeywords.name = 'keywords';
        document.head.appendChild(metaKeywords);
      }
      metaKeywords.content = keywords;
    }

    // Add Open Graph tags
    const ogTags = [
      { property: 'og:title', content: pageTitle },
      { property: 'og:description', content: pageDescription },
      { property: 'og:type', content: 'website' },
      { property: 'og:site_name', content: 'Delta Valley Health Club' },
      { property: 'og:locale', content: 'en_US' },
    ];

    ogTags.forEach(({ property, content }) => {
      let meta = document.querySelector(`meta[property="${property}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('property', property);
        document.head.appendChild(meta);
      }
      meta.content = content;
    });

    // Add Twitter Card tags
    const twitterTags = [
      { name: 'twitter:card', content: 'summary_large_image' },
      { name: 'twitter:title', content: pageTitle },
      { name: 'twitter:description', content: pageDescription },
    ];

    twitterTags.forEach(({ name, content }) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.name = name;
        document.head.appendChild(meta);
      }
      meta.content = content;
    });

    // Handle JSON-LD schema
    if (schema) {
      // Remove existing schemas
      document.querySelectorAll('script[data-seo-schema]').forEach(el => el.remove());

      const schemas = Array.isArray(schema) ? schema : [schema];
      schemas.forEach((s, i) => {
        const schemaScript = document.createElement('script');
        schemaScript.type = 'application/ld+json';
        schemaScript.setAttribute('data-seo-schema', 'true');
        schemaScript.textContent = JSON.stringify(normalizeSchemaUrls(s));
        document.head.appendChild(schemaScript);
      });
    }

    // Cleanup function
    return () => {
      document.querySelectorAll('script[data-seo-schema]').forEach(el => el.remove());
    };
  }, [title, description, keywords, schema]);

  return null;
};

export default SEO;
